module.exports = __webpack_public_path__ + "img/racetrack-turffontein-turf-standside.3986a673.svg";